import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid1x2 = (): GridInterface[] =>
  defineGrid(
    '1:2',
    [
      {
        name: 'Sitebar',
        rows: [
          {
            columns: [
              {
                tileId: 0,
                spanCol: 2,
              },
            ],
          },
          {
            columns: [
              {
                tileId: 1,
              },
              {
                tileId: 2,
              },
            ],
          },
        ],
      },
    ],
    2,
    2,
  );
